import {Success} from 'common/models/success';

interface GetShowFlagsResult {
    message: boolean;
    share: boolean;
    results: boolean;
    stats: boolean;
    integrations: boolean;
    promo: boolean;
}

export const {iframe, shareOnSuccess} = window.YC;

export const getShowFlags = (
    isShareResult: string | null,
    successData: Success,
): Partial<GetShowFlagsResult> => {
    if (isShareResult) {
        return {
            message: true,
        };
    }

    const show = {
        message: true,
        share: shareOnSuccess && successData.share !== false,
        promo: successData.teaser !== false,
        results: Boolean(successData.correct),
        stats: Boolean(successData.stats),
        integrations: Boolean(successData.integrations?.length),
    };

    if (iframe) {
        show.share = false;
        show.promo = false;
    }

    return show;
};
